// extracted by mini-css-extract-plugin
module.exports = {"leaderboardTableContainer":"Leaderboard_leaderboardTableContainer__opKKE","leaderboard":"Leaderboard_leaderboard__2NmER","profit":"Leaderboard_profit__200lk"};